// extracted by mini-css-extract-plugin
module.exports = {"value":"TreatsConversion-module--value--26133a","sign":"TreatsConversion-module--sign--2bfb40","label":"TreatsConversion-module--label--6bd42b"};